import { downloadBlob } from '@/shared/lib/export-utils';

export interface LogRow {
  date: string;
  time: string;
  action: string;
  notes: string;
  verifier: string;
  manager: string;
}

function csvEscape(value: string): string {
  if (value == null) return '';
  const needsQuoting = /[",\n\r]/.test(value);
  const escaped = value.replace(/"/g, '""');
  return needsQuoting ? `"${escaped}"` : escaped;
}

/**
 * Generates a CSV blob from log rows and triggers a browser download.
 * Works entirely client-side — no backend round-trip needed.
 */
export function downloadLogCsv(rows: LogRow[], filename: string): void {
  const header = ['Date', 'Time', 'Action', 'Notes', 'By', 'Manager'];
  const body = rows.map((row) =>
    [row.date, row.time, row.action, row.notes, row.verifier, row.manager].map(csvEscape).join(','),
  );
  const csv = [header.join(','), ...body].join('\n');
  downloadBlob(csv, filename, 'text/csv;charset=utf-8;');
}
